module.exports = {"URL":"https://aluno.top-trader.org","API_URL":"https://api.aluno.top-trader.org/api","TOKEN_NAME":"token","NODE_ENV":"production"}


//////////////////
// WEBPACK FOOTER
// ./src/utils/config/prod.env.json
// module id = J0Ej
// module chunks = 4